var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
/**
 * Consistent hyperlink button component for interactive text links
 * Provides standardized styling and hover effects across the application
 */
export var LinkButton = function (_a) {
    var children = _a.children, onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.style, style = _c === void 0 ? {} : _c, title = _a.title, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var handleClick = function (e) {
        e.preventDefault();
        if (!disabled) {
            onClick(e);
        }
    };
    var defaultStyle = __assign({ color: "#007bff", textDecoration: "none", fontSize: "14px", fontWeight: "500", cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1, transition: "color 0.2s ease" }, style);
    return (React.createElement("a", { href: "#", onClick: handleClick, className: className, style: defaultStyle, title: title, onMouseEnter: function (e) {
            if (!disabled) {
                e.currentTarget.style.color = "#0056b3";
            }
        }, onMouseLeave: function (e) {
            if (!disabled) {
                e.currentTarget.style.color = "#007bff";
            }
        } }, children));
};
export default LinkButton;
